import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {Button} from 'reactstrap';
import ButtonGroup from '@mui/material/ButtonGroup';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import MuiTable from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { openFile, byteSize, Translate, TextFormat, getPaginationState, JhiPagination, JhiItemCount } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities } from './tour-extra.reducer';

export const TourExtra = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const tourExtraList = useAppSelector(state => state.tourExtra.entities);
  const loading = useAppSelector(state => state.tourExtra.loading);
  const totalItems = useAppSelector(state => state.tourExtra.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      }),
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    } else {
      return order === ASC ? faSortUp : faSortDown;
    }
  };

  return (
    <div>
      <h2 id="tour-extra-heading" data-cy="TourExtraHeading">
        <Translate contentKey="jhipsterSampleApplicationApp.tourExtra.home.title">Tour Extras</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" onClick={handleSyncList} disabled={loading} variant="outlined" startIcon={<FontAwesomeIcon icon="sync" spin={loading} />}>
            <Translate contentKey="jhipsterSampleApplicationApp.tourExtra.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Button component={Link} to="/tour-extra/new" variant="contained" color="primary" id="jh-create-entity" data-cy="entityCreateButton" startIcon={<FontAwesomeIcon icon="plus" />}>
            <Translate contentKey="jhipsterSampleApplicationApp.tourExtra.home.createLabel">Create new Tour Extra</Translate>
          </Button>
        </div>
      </h2>
      <div className="table-responsive">
        {tourExtraList && tourExtraList.length > 0 ? (
          <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
            <MuiTable>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 700, cursor: 'pointer' }} onClick={sort('id')}>
                    <Translate contentKey="jhipsterSampleApplicationApp.tourExtra.id">ID</Translate>{' '}
                    <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                  </TableCell>
                  <TableCell sx={{ fontWeight: 700, cursor: 'pointer' }} onClick={sort('code')}>
                    <Translate contentKey="jhipsterSampleApplicationApp.tourExtra.code">Code</Translate>{' '}
                    <FontAwesomeIcon icon={getSortIconByFieldName('code')} />
                  </TableCell>
                  <TableCell sx={{ fontWeight: 700, cursor: 'pointer' }} onClick={sort('enabled')}>
                    <Translate contentKey="jhipsterSampleApplicationApp.tourExtra.enabled">Enabled</Translate>{' '}
                    <FontAwesomeIcon icon={getSortIconByFieldName('enabled')} />
                  </TableCell>
                  <TableCell sx={{ fontWeight: 700, cursor: 'pointer' }} onClick={sort('icon')}>
                    <Translate contentKey="jhipsterSampleApplicationApp.tourExtra.icon">Icon</Translate>{' '}
                    <FontAwesomeIcon icon={getSortIconByFieldName('icon')} />
                  </TableCell>
                  <TableCell sx={{ fontWeight: 700, cursor: 'pointer' }} onClick={sort('price')}>
                    <Translate contentKey="jhipsterSampleApplicationApp.tourExtra.price">Price</Translate>{' '}
                    <FontAwesomeIcon icon={getSortIconByFieldName('price')} />
                  </TableCell>
                  <TableCell sx={{ fontWeight: 700, cursor: 'pointer' }} onClick={sort('offer')}>
                    <Translate contentKey="jhipsterSampleApplicationApp.tourExtra.offer">Offer</Translate>{' '}
                    <FontAwesomeIcon icon={getSortIconByFieldName('offer')} />
                  </TableCell>
                  <TableCell sx={{ fontWeight: 700, cursor: 'pointer' }} onClick={sort('shopProductId')}>
                    <Translate contentKey="jhipsterSampleApplicationApp.tourExtra.shopProductId">Shop Product Id</Translate>{' '}
                    <FontAwesomeIcon icon={getSortIconByFieldName('shopProductId')} />
                  </TableCell>
                  <TableCell sx={{ fontWeight: 700, cursor: 'pointer' }} onClick={sort('shopUrl')}>
                    <Translate contentKey="jhipsterSampleApplicationApp.tourExtra.shopUrl">Shop Url</Translate>{' '}
                    <FontAwesomeIcon icon={getSortIconByFieldName('shopUrl')} />
                  </TableCell>
                  <TableCell sx={{ fontWeight: 700, cursor: 'pointer' }} onClick={sort('createdDate')}>
                    <Translate contentKey="jhipsterSampleApplicationApp.tourExtra.createdDate">Created Date</Translate>{' '}
                    <FontAwesomeIcon icon={getSortIconByFieldName('createdDate')} />
                  </TableCell>
                  <TableCell sx={{ fontWeight: 700, cursor: 'pointer' }} onClick={sort('defaultImage')}>
                    <Translate contentKey="jhipsterSampleApplicationApp.tourExtra.defaultImage">Default Image</Translate>{' '}
                    <FontAwesomeIcon icon={getSortIconByFieldName('defaultImage')} />
                  </TableCell>
                  <TableCell sx={{ fontWeight: 700, cursor: 'pointer' }} onClick={sort('defaultImageData')}>
                    <Translate contentKey="jhipsterSampleApplicationApp.tourExtra.defaultImageData">Default Image Data</Translate>{' '}
                    <FontAwesomeIcon icon={getSortIconByFieldName('defaultImageData')} />
                  </TableCell>
                  <TableCell>
                    <Translate contentKey="jhipsterSampleApplicationApp.tourExtra.createdBy">Created By</Translate>{' '}
                    <FontAwesomeIcon icon="sort" />
                  </TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {tourExtraList.map((tourExtra, i) => (
                  <TableRow key={`entity-${i}`} data-cy="entityTable">
                    <TableCell>
                      <Button component={Link} to={`/tour-extra/${tourExtra.id}`} variant="text" size="small">
                        {tourExtra.id}
                      </Button>
                    </TableCell>
                    <TableCell>{tourExtra.code}</TableCell>
                    <TableCell>{tourExtra.enabled ? 'true' : 'false'}</TableCell>
                    <TableCell>{tourExtra.icon}</TableCell>
                    <TableCell>{tourExtra.price}</TableCell>
                    <TableCell>{tourExtra.offer}</TableCell>
                    <TableCell>{tourExtra.shopProductId}</TableCell>
                    <TableCell>{tourExtra.shopUrl}</TableCell>
                    <TableCell>
                      {tourExtra.createdDate ? <TextFormat type="date" value={tourExtra.createdDate} format={APP_LOCAL_DATE_FORMAT} /> : null}
                    </TableCell>
                    <TableCell>{tourExtra.defaultImage}</TableCell>
                    <TableCell>
                      {tourExtra.defaultImageData ? (
                        <div>
                          {tourExtra.defaultImageDataContentType ? (
                            <a onClick={openFile(tourExtra.defaultImageDataContentType, tourExtra.defaultImageData)}>
                              <img
                                src={`data:${tourExtra.defaultImageDataContentType};base64,${tourExtra.defaultImageData}`}
                                style={{ maxHeight: '30px' }}
                              />
                              &nbsp;
                            </a>
                          ) : null}
                          <span>
                            {tourExtra.defaultImageDataContentType}, {byteSize(tourExtra.defaultImageData)}
                          </span>
                        </div>
                      ) : null}
                    </TableCell>
                    <TableCell>{tourExtra.createdBy ? tourExtra.createdBy.login : ''}</TableCell>
                    <TableCell className="text-end">
                      <ButtonGroup variant="outlined" size="small" aria-label="entity actions">
                        <Button component={Link} to={`/tour-extra/${tourExtra.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`} color="primary" startIcon={<FontAwesomeIcon icon="pencil-alt" />} data-cy="entityEditButton">
                        </Button>
                        <Button onClick={() => (window.location.href = `/tour-extra/${tourExtra.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)} color="error" startIcon={<FontAwesomeIcon icon="trash" />} data-cy="entityDeleteButton">
                        </Button>
                      </ButtonGroup>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </MuiTable>
          </TableContainer>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="jhipsterSampleApplicationApp.tourExtra.home.notFound">No Tour Extras found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={tourExtraList && tourExtraList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default TourExtra;
